module.exports = __webpack_public_path__ + "img/checkbox-active.2591dd66.svg";